import { toast } from '@/utils/toastManager';

/**
 * Returns the app toast manager (Sonner-backed). No Chakra dependency.
 */
export const useToastManager = () => toast;
